import { Box } from "@mui/system";
import * as React from "react";

import { useResizeContext } from "./use-resize";

export const ResizeHandle = (props) => {
  const styles = {
    position: "absolute",
    userSelect: "none",
    width: "10px",
    height: "100%",
    top: "0px",
    cursor: "col-resize",
  };

  const context = useResizeContext();

  if (context?.isResizable === false) {
    return null;
  }

  return <Box {...props} {...context?.getHandleProps()} __css={styles} />
};

ResizeHandle.displayName = "ResizeHandle";
